function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import { SovosBox, SovosTypography } from "mosaic-react";
const StateInfoTab = props => {
  const {
    icon,
    children,
    style,
    variant,
    color,
    ...rest
  } = props;
  let {
    info
  } = props;
  if (!info) {
    info = new Date().toISOString().replace("T", " ").substring(0, 19).split(" ")[1];
  }
  const direction = variant ? "column" : "row";
  const boxStyles = {
    display: "flex",
    flexDirection: direction,
    color: color ?? "black"
  };
  const textStyles = {
    marginLeft: "8px",
    color: color ?? "black"
  };
  return /*#__PURE__*/React.createElement(SovosBox, _extends({}, rest, {
    style: boxStyles
  }), icon, /*#__PURE__*/React.createElement(SovosTypography, {
    style: textStyles,
    variant: "h6"
  }, children, " ", /*#__PURE__*/React.createElement("span", null, info)));
};
export default StateInfoTab;